import React, { useState, useEffect } from "react";
import { putProducto as modifProducto } from "../helpers/rutaProductos";
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import 'animate.css';

const ModalFormProducto = ({ producto, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    codpro: "",
    producto: "",
  });

  useEffect(() => {
    if (producto && producto._id) {
      setFormValues({
        codpro: producto.codpro || "",
        producto: producto.producto || "",
      });
    }
  }, [producto]);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await modifProducto(producto._id, formValues);
      console.log("✅ Producto actualizado:", resp);

      setShowSuccess(true); // Mostrar el modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultarlo después de 2 segundos
        handleClose();         // Cerrar el modal principal
      }, 2000);
    } catch (error) {
      console.error("❌ Error al actualizar producto:", error);
      // Podés mostrar un modal de error si querés
    }
  };


  // const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  // const [rutas, setRutas] = useState({ data: {}, loading: true });

  // useEffect(() => {
  //   getLocalidades().then((res) =>
  //     setLocalidades({ data: res, loading: false })
  //   );
  //   getRutas().then((res) => setRutas({ data: res, loading: false }));
  // }, []);

  return (
    <>
    <Modal show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Producto</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mt-2">
            <label>Producto</label>
            <input
              type="text"
              className="form-control"
              name="producto"
              required
              value={formValues.producto}
              onChange={handleChange}
            />
          </div>

          {/* <div className="form-group mt-2">
            <label>Patente</label>
            <input
              type="text"
              className="form-control"
              name="patente"
              required
              value={formValues.patente}
              onChange={handleChange}
            />
          </div> */}

          {/* <div className="form-group mt-2">
            <label>Localidad</label>
            <select
              className="form-control"
              name="localidad"
              value={formValues.localidad}
              onChange={handleChange}
              required
            >
              <option value="">Elija una opción</option>
              {localidades.data.localidades &&
                localidades.data.localidades.map((loc) => (
                  <option key={loc._id} value={loc._id}>
                    {loc.localidad}
                  </option>
                ))}
            </select>
          </div> */}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button type="submit" variant="dark">
            Guardar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>

    <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
      <Modal.Body className="text-center">
        <div style={{ fontSize: "3rem" }}>🖐</div>
        <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormProducto;
